const aggregateCount = (data = [], param) =>{
    let initialValue = 0
    let sum = data && data.reduce(function (accumulator, curValue) {
        return accumulator + curValue[param]
    }, initialValue)
    return sum
}

export default aggregateCount